






















import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { androidStatusBarHeight } from "@/utils/statusBarHeight";
@Component({
  components: {
    // [Tabbar.name]: Tabbar,
  }
})
export default class NavBar extends Vue {
  @Prop({ default: false })
  private transparent?: boolean;
  @Prop({ default: false })
  private border?: boolean;
  @Prop({ default: false })
  private leftBack?: boolean;
  @Prop({ default: false })
  private leftFork?: boolean;
  @Prop({ default: false })
  private flowLayout?: boolean;

  private mounted() {}

  @Emit("clickLeft")
  private clickLeft() {}

  @Emit("clickMid")
  private clickMid() {}

  @Emit("clickRight")
  private clickRight() {}

  get androidStatusBarHeight() {
    return androidStatusBarHeight;
  }
}
